module.exports = __webpack_public_path__ + "media/favicon/favicon-32x32-a4faa18b.png";